import React from "react";
import styles from "./styles.css";
const CURRENT_YEAR = new Date().getFullYear();
function Footer() {
    return (React.createElement("footer", { className: styles.wideContainer },
        React.createElement("div", { className: styles.container },
            React.createElement("small", { className: styles.currentYear }, CURRENT_YEAR),
            React.createElement("small", { className: styles.author }, "Mr. Oleski"))));
}
export default Footer;
